
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskTemplateModel } from './Entities.GormCrm.TaskTemplate';
import { TaskAreaModel } from './Entities.GormCrm.TaskArea';
import { TaskAttachmentModel } from './Entities.GormCrm.TaskAttachment';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { TaskActionType } from 'enums/TaskActionType';
import { Model, ModelProperty } from 'models/Model';


export class TaskActionModel extends Model<TaskActionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'taskflowId', type: 'string' },
		{ name: 'sourceTemplateId', type: 'string' },
		{ name: 'details', type: 'string' },
		{ name: 'assignedToUserId', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'completed', type: 'Date' },
		{ name: 'plannedDate', type: 'Date' },
		{ name: 'dateOnly', type: 'boolean' },
		{ name: 'taskAreaId', type: 'string' },
		{ name: 'additionalData', type: 'string' },
		{ name: 'step', type: 'number' },
		{ name: 'trackingId', type: 'string' },
		{ name: 'createdById', type: 'string' },
		{ name: 'canceled', type: 'boolean' },
		{ name: 'sourceTemplate', type: 'TaskTemplateModel', isHidden: true, isObject: true, new: () => { return new TaskTemplateModel }, properties: () => { return TaskTemplateModel.classProperties } },
		{ name: 'taskArea', type: 'TaskAreaModel', isHidden: true, isObject: true, new: () => { return new TaskAreaModel }, properties: () => { return TaskAreaModel.classProperties } },
		{ name: 'taskAttachments', type: 'TaskAttachmentModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskAttachmentModel }, properties: () => { return TaskAttachmentModel.classProperties } },
		{ name: 'taskflow', type: 'TaskflowModel', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } },
		{ name: 'type', type: 'TaskActionType' }
	];
	[key: string]: any;
	
	public id?: string;
	public taskflowId?: string;
	public sourceTemplateId?: string;
	public details: string;
	public assignedToUserId?: string;
	public created?: Date;
	public completed?: Date;
	public plannedDate?: Date;
	public dateOnly: boolean;
	public taskAreaId?: string;
	public additionalData: string;
	public step: number;
	public trackingId: string;
	public createdById?: string;
	public canceled: boolean;
	public sourceTemplate?: TaskTemplateModel;
	public taskArea?: TaskAreaModel;
	public taskAttachments: TaskAttachmentModel[];
	public taskflow?: TaskflowModel;
	public type: TaskActionType;
    
	constructor(){
		super();
		this.id = undefined;
		this.taskflowId = undefined;
		this.sourceTemplateId = undefined;
		this.details = '';
		this.assignedToUserId = undefined;
		this.created = undefined;
		this.completed = undefined;
		this.plannedDate = undefined;
		this.dateOnly = false;
		this.taskAreaId = undefined;
		this.additionalData = '';
		this.step = 0;
		this.trackingId = '';
		this.createdById = undefined;
		this.canceled = false;
		this.sourceTemplate = undefined;
		this.taskArea = undefined;
		this.taskAttachments = [];
		this.taskflow = undefined;
		this.type = 0;
		
	}
	getProperties(){
		return TaskActionModel.classProperties;
	}
}

